var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "currency-dollar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.83301 14.6667C8.83301 15.9553 9.87768 17 11.1663 17H13.333C14.7137 17 15.833 15.8807 15.833 14.5C15.833 13.1193 14.7137 12 13.333 12H11.333C9.9523 12 8.83301 10.8807 8.83301 9.5C8.83301 8.11929 9.9523 7 11.333 7H13.4997C14.7883 7 15.833 8.04467 15.833 9.33333M12.333 5.5V7M12.333 17V18.5M22.333 12C22.333 17.5228 17.8559 22 12.333 22C6.81016 22 2.33301 17.5228 2.33301 12C2.33301 6.47715 6.81016 2 12.333 2C17.8559 2 22.333 6.47715 22.333 12Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyDollarCircle);
export default __webpack_public_path__ + "static/media/currency-dollar-circle.6d90c749f34411af1ceb03130092b4df.svg";
export { ForwardRef as ReactComponent };